import { jsx } from 'react/jsx-runtime';
import * as CheckboxPrimitive from '@radix-ui/react-checkbox';
import classNames from 'classnames';
import { forwardRef, useMemo } from 'react';
import { CheckIcon } from '../icons/CheckIcon.mjs';
import { IndeterminateIcon } from '../icons/IndeterminateIcon.mjs';
import { checkboxIndicator } from './indicator.vanilla.mjs';

const CheckboxIndicator = forwardRef(
  ({ checked, className: classNameFromProps, forceMount = true, ...props }, forwardedRef) => {
    const className = classNames(checkboxIndicator, classNameFromProps);
    const isIndeterminate = typeof checked === "string" && checked === "indeterminate";
    const icon = useMemo(
      () => isIndeterminate ? /* @__PURE__ */ jsx(IndeterminateIcon, {}) : checked ? /* @__PURE__ */ jsx(CheckIcon, {}) : null,
      [checked, isIndeterminate]
    );
    return /* @__PURE__ */ jsx(
      CheckboxPrimitive.Indicator,
      {
        "data-scope": "checkbox",
        "data-part": "indicator",
        className,
        forceMount,
        ref: forwardedRef,
        ...props,
        children: icon
      }
    );
  }
);
CheckboxIndicator.displayName = "Checkbox.Indicator";

export { CheckboxIndicator };
//# sourceMappingURL=Indicator.mjs.map
